import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { pageLoader } from '../../services/PageLoader';
import { Fade } from 'reactstrap';

export const LazyPage = withRouter(class LazyPage extends Component {
    constructor(props) {
      super(props);

      setTimeout(() => {
        pageLoader.addPageToLazyLoadedPages(this.props.match.path);
      }, 0)
    }

    render() {
      // Component loaded
      if (false && !pageLoader.isPageLoaded(this.props.match.path)) {
        return (
          <Fade timeout={0}>
            {this.props.children}
          </Fade>
        );
      }

      return this.props.children;
    }
  }
);
